<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import DButton from '#layers/ui/components/Button.vue';

defineOptions({
	name: 'ButtonDestructive',
});

withDefaults(defineProps<ButtonProps>(), {
	variant: 'ghost',
	color: 'neutral',
	// Otherwise both are set to `false` and NuxtLink will detect a conflict
	prefetch: undefined,
	noPrefetch: undefined,
});
</script>

<template>
	<DButton
		class="hover:text-error focus-visible:text-error"
		v-bind="{ ...$attrs, ...$props }"
	>
		<slot />
	</DButton>
</template>
